export const initialUserStage = JSON.stringify({
  listingTool: false,
  importingCatalog: false,
  allSet: false,
});
